module.exports = __webpack_public_path__ + "static/img/bgimg3.1ba77878.png";